<template>
  <div class="container-fluid about pt-4" >
      <!-- Image Showcases -->
  <section class="showcase">
    <div class=" p-0">
      <div class="row no-gutters">

        <div class="col-lg-6 order-lg-2 text-white showcase-img " :style="banjir"></div>
        <div class="col-lg-6 order-lg-1 my-auto showcase-text">
          <!-- <h2>Awal</h2> -->
          <p class="lead mb-0">Berdiri pada medio Juni 2019, KOMPAS (Komunitas Pengamat Air Sungai) BONTANG mrupakan komunitas nirlaba yang bergerak dalam 
        bidang pemanfaatan teknologi terapan dalam menunjang visi kota Bontang sebagai smart city. 
        Komunitas berfokus pada bidang pemantauan kondisi lingkungan sekitar dengan menggunakan teknologi IoT (Internet Of Things).</p>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col-lg-6 text-white showcase-img" :style="project1">
       </div>
        <div class="col-lg-6 my-auto showcase-text">
          <!-- <h2>Perencanaan</h2> -->
          <p class="lead mb-0"><p>
        Project pertama yang dikembangkan dan masih berlangsung sampai saat ini adalah pemantauan level ketinggian daerah aliran sungai secara otomatis , 
        bermaksud untuk memberikan data real-time mengenai level air di Daerah sungai Bontang, menggunakan perangkat AWLR (Automatic Water Level Recorder) berbasis IoT. 
      </p>
      <P>
        Pembuatan project ini didasarkan pada kejadian banjir besar yang melanda kota Bontang pada medio Juni yang membawa dampak cukup signifikan pada Kota Bontang, 
        hampir setengah akses kota Bontang tidak dapat dilalui, harapan kedepan perangkat-perangkat yang diaplikasikan oleh 
        KOMPAS BONTANG dapat digunakan sebagai sarana “data driven” untuk mitigasi risiko Tindakan terhadap bencana alam.
      </P>
        </div>
        
      </div>
      <div class="row no-gutters pb-4">
        <div class="col-lg-6 order-lg-2 text-white showcase-img" :style="project2"></div>
        <div class="col-lg-6 order-lg-1 my-auto showcase-text">
          <!-- <h2>Harapan</h2> -->
          <p class="lead mb-0">Sesuai dengan semangat membawa teknologi terapan untuk bisa digunakan masyrakat,
         KOMPAS BONTANG berusaha terus untuk berinovasi menyesuaikan arah pengembangan kota Bontang, masih banyak project-project lain 
         yang akan dikembangkan dengan mengadopsi teknologi terkini seperti Internet of Things, big data, artificial intelligence , dan apps. 
         Digawangi oleh pemuda-pemudi lokal asal Bontang, kami yakin dan mampu bahwa dapat berkontribusi banyak dalam membantu para stakeholder 
         dalam mengembangkan kota BONTANG sebagai smart city. </p>
        </div>
      </div>
    </div>
  </section>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        banjir: {
          backgroundImage: `url(${require('@/assets/img/banjir.jpeg')})`
        },
         project1: {
          backgroundImage: `url(${require('@/assets/img/project1.jpeg')})`
        },
         project2: {
         backgroundImage: `url(${require('@/assets/img/project2.jpeg')})`
        }
      }
    }
  }
</script>

<style >

.showcase .showcase-text {
  padding: 3rem;
}

.showcase .showcase-img {
  min-height: 30rem;
  background-size: cover;
}

@media (min-width: 768px) {
  .showcase .showcase-text {
    padding: 7rem;
  }
}
</style>